import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

export default function ItemDetailsScreen() {
  const { id } = useParams(); // Get the item ID from the URL
  const [item, setItem] = useState(null); // State to hold the item details
  const [error, setError] = useState(null); // State for error handling
  const [currentImageIndex, setCurrentImageIndex] = useState(0); // Track the current image

  useEffect(() => {
    const fetchItem = async () => {
      try {
        // Fetch item data from the backend
        const response = await axios.get(`https://foodgyde.com/api/fetch_item.php?id=${id}`);
        setItem(response.data);
      } catch (err) {
        console.error("Error fetching item:", err);
        setError("Unable to fetch item details.");
      }
    };

    fetchItem();
  }, [id]);

  // If there's an error
  if (error) {
    return <div className="p-4 text-red-500">{error}</div>;
  }

  // While loading
  if (!item) {
    return <div className="p-4 text-gray-500">Loading item details...</div>;
  }

  // Split multiple image paths (if stored as a comma-separated string)
  const images = item.imagePath ? item.imagePath.split(",").map(img => img.trim()).slice(0, 6) : [];

  // Function to move to the previous image
  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  // Function to move to the next image
  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="w-full bg-blue-600 p-4 text-white text-center text-lg font-bold">
        Item Details
      </header>
      <main className="p-4 max-w-2xl mx-auto bg-white rounded-md shadow">

        {/* Image Carousel */}
        {images.length > 0 && (
          <div className="relative w-full flex items-center justify-center mb-4">
            <button
              onClick={handlePrevImage}
              className="absolute left-0 px-3 py-2 bg-gray-800 text-white rounded-md shadow hover:bg-gray-700"
            >
              ◀
            </button>
            <img
              src={images[currentImageIndex] || "https://example.com/placeholder.jpg"}
              alt={`Item ${currentImageIndex + 1}`}
              style={{ width: "300px", height: "300px", objectFit: "cover", borderRadius: "8px" }}
            />


            <button
              onClick={handleNextImage}
              className="absolute right-0 px-3 py-2 bg-gray-800 text-white rounded-md shadow hover:bg-gray-700"
            >
              ▶
            </button>
          </div>
        )}

        {/* Item Information */}
        <h1 className="text-2xl font-bold">{item.name}</h1>
        <p className="text-gray-600 mt-2">{item.description}</p>

        {/* Price & Barcode */}
        <p className="text-blue-600 font-semibold mt-4 text-lg">${item.price}</p>
        <p className="text-gray-700 mt-2"><strong>Barcode:</strong> {item.barcode}</p>

        {/* Ingredients */}
        {item.ingredients && (
          <div className="mt-4">
            <h3 className="text-gray-800 font-semibold">Ingredients</h3>
            <p className="text-gray-600">{item.ingredients}</p>
          </div>
        )}

        {/* Nutrition Facts (If Available) */}
        {item.nutritionFacts && (
          <div className="mt-4">
            <h3 className="text-gray-800 font-semibold">Nutrition Facts</h3>
            <p className="text-gray-600">{item.nutritionFacts}</p>
          </div>
        )}

        {/* Back Button */}
        <button
          onClick={() => window.history.back()} // Go back to the previous screen
          className="mt-4 px-6 py-2 bg-gray-600 text-white rounded-md shadow hover:bg-gray-700"
        >
          Back
        </button>

      </main>
    </div>
  );
}
